import { gxfeeuploadApi } from "@/app/apiConfig/services/authAbstractApiLayer";
import { getDocRefId } from "@/app/utils/loginFlow/generateDocRefId";
import { useState } from "react";

type DocumentType = "LOGO" | "TRADE LICENSE" | "OWNERSHIP DOCUMENT";

interface GlobalFileUploadResult {
  logoPreview: string | null;
  docPreview: string | null;
  pdfPreview: string | null;
  uploadedLogo: any | null;
  uploadedDoc: any | null;
  uploadedPdf: any | null;
  fileLoading: boolean;
  fileError: string | null;
  handleLogoUpload: (file: File | null) => Promise<void>;
  handleDocUpload: (file: File | null) => Promise<void>;
  handlePdfUpload: (file: File | null) => Promise<void>;
  setLogoPreview: (value: string | null) => void;
  setDocPreview: (value: string | null) => void;
  setPdfPreview: (value: string | null) => void;
  setUploadedLogo: (value: any | null) => void;
}

export const GlobalFileUpload = (): GlobalFileUploadResult => {
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [docPreview, setDocPreview] = useState<string | null>(null);
  const [pdfPreview, setPdfPreview] = useState<string | null>(null);
  const [uploadedLogo, setUploadedLogo] = useState<any | null>(null);
  const [uploadedDoc, setUploadedDoc] = useState<any | null>(null);
  const [uploadedPdf, setUploadedPdf] = useState<any | null>(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [fileError, setFileError] = useState<string | null>(null);

  const uploadFile = async (file: File | null, type: DocumentType) => {
    if (!file) return;

    const fd = new FormData();
    fd.append("file", file);
    fd.append("documentType", type);
    fd.append("docRefId", getDocRefId());
    setFileLoading(true);
    setFileError(null);

    try {
      const response = await gxfeeuploadApi(fd);

      switch (type) {
        case "LOGO":
          setLogoPreview(URL.createObjectURL(file));
          setUploadedLogo(response?.data);
          break;
        case "TRADE LICENSE":
          setDocPreview(file.name);
          setUploadedDoc(response?.data);
          break;
        case "OWNERSHIP DOCUMENT":
          setPdfPreview(file.name);
          setUploadedPdf(response?.data);
          break;
      }
    } catch (err: any) {
      setFileError("Upload failed");
    } finally {
      setFileLoading(false);
    }
  };

  return {
    logoPreview,
    docPreview,
    pdfPreview,
    uploadedLogo,
    uploadedDoc,
    uploadedPdf,
    setUploadedLogo,
    setLogoPreview,
    setDocPreview,
    setPdfPreview,
    fileLoading,
    fileError,
    handleLogoUpload: (file) => uploadFile(file, "LOGO"),
    handleDocUpload: (file) => uploadFile(file, "TRADE LICENSE"),
    handlePdfUpload: (file) => uploadFile(file, "OWNERSHIP DOCUMENT"),
  };
};
